import enBase from "./en.json";
import apiErrors from "./api-errors.en.json";
import travelersInfo from "@/features/travelers-info/locales/en.json";
import passportInfo from "@/features/passport-info/locales/en.json";
import quoteList from "@/features/quote-list/locales/en.json";
import policySummary from "@/features/policy-summary/locales/en.json";
import postPayment from "@/features/post-payment/locales/en.json";
import common from "./common.en.json";
import iban from "@/features/iban/locales/en.json";
import receipt from "@/features/receipt/locales/en.json";

export default {
  ...enBase,
  apiErrors,
  travelersInfo,
  passportInfo,
  quoteList,
  policySummary,
  postPayment,
  common,
  iban,
  receipt,
} as const;
